var _excluded = ["disabled"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import DisplayElement from "../DisplayElement/index.js";
var DisplayButton = function DisplayButton(_ref) {
  var disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(DisplayElement, _extends({
    as: "button",
    htmlDisabled: disabled
  }, props));
};
DisplayButton.defaultProps = {
  onClick: noop,
  type: 'button'
};
process.env.NODE_ENV !== "production" ? DisplayButton.propTypes = {
  /**
   * Disable button
   */
  disabled: PropTypes.bool,
  /**
   * Click handler. Not required for links. Other `DisplayLink` properties can also be passed.
   */
  onClick: PropTypes.func,
  /**
   * button type. See [MDN's <button> page](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#attr-type) for more details
   */
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
} : void 0;
export default DisplayButton;